import { BaseFetch } from "../main-model"
export default class ClassroomModel extends BaseFetch {
  getClassroomBy = (data) =>
    this.authFetch({
      url: "classroom/getClassroomBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getClassroomById = (data) =>
    this.authFetch({
      url: "classroom/getClassroomById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateClassroomById = (data) =>
    this.authFetch({
      url: "classroom/updateClassroomById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertClassroom = (data) =>
    this.authFetch({
      url: "classroom/insertClassroom",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteClassroomById = (data) =>
    this.authFetch({
      url: "classroom/deleteClassroomById",
      method: "POST",
      body: JSON.stringify(data),
    })
    checkClassRoom = (data) =>
    this.authFetch({
      url: "classroom/checkClassRoom",
      method: "POST",
      body: JSON.stringify(data),
    })
}
